"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPack = exports.extractProductIdsFromPack = void 0;
const extractProductIdsFromPack = (pack) => {
    const productIdsFromPack = [];
    for (const packToStep of pack.packToSteps) {
        for (const stepToProductVariation of packToStep.step.stepToProductVariations) {
            productIdsFromPack.push(stepToProductVariation.productVariation.productId);
        }
    }
    for (const packToProductVariation of pack.packToProductVariations) {
        productIdsFromPack.push(packToProductVariation.productVariation.productId);
    }
    return productIdsFromPack;
};
exports.extractProductIdsFromPack = extractProductIdsFromPack;
const isPack = (object) => {
    return 'packToSteps' in object;
};
exports.isPack = isPack;
